
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface UserReport {
  uuid_report: string;
  id: string;
  created_at: string;
  area: string;
  building_type: string;
  floor_size: number;
  occupants: number;
  energy_rating: string;
  tot_ann_sav_pot: number;
  tot_one_off_cost: number;
  efficiency_score: number;
  // Gas metrics
  gas_avg_cost: number;
  gas_diff_your_cost: number;
  gas_curr_cost: number;
  gas_use_sav_pot: number;
  gas_use_tot_sav: number;
  gas_price_sav_pot: number;
  gas_price_tot_sav: number;
  gas_comb_sav_pot: number;
  gas_comb_sav_pot_perc: number;
  // Electricity metrics
  elec_avg_cost: number;
  elec_diff_your_cost: number;
  elec_curr_cost: number;
  elec_use_sav_pot: number;
  elec_use_tot_sav: number;
  elec_price_sav_pot: number;
  elec_price_tot_sav: number;
  elec_comb_sav_pot: number;
  elec_comb_sav_pot_perc: number;
  // Water metrics
  water_avg_cost: number;
  water_diff_your_cost: number;
  water_curr_cost: number;
  water_use_sav_pot: number;
  water_use_tot_sav: number;
  water_comb_sav_pot: number;
  water_comb_sav_pot_perc: number;
  // Tariff recommendations
  tariff_best: string;
  tariff_gas_sav: number;
  tariff_elec_sav: number;
  tarif_ann_sav: number;
  tariff_link: string;
  // Water and heating recommendations
  showerhead_sav: number;
  showerhead_cost: number;
  showerhead_link: string;
  taps_sav: number;
  taps_cost: number;
  taps_link: string;
  cistern_sav: number;
  cistern_cost: number;
  cistern_link: string;
  insulation_sav: number;
  insulation_cost: number;
  insulation_link: string;
  chimney_sav: number;
  chimney_cost: number;
  chimney_link: string;
  draft_sav: number;
  draft_cost: number;
  draft_link: string;
  // New water savings metrics
  litres_saved: number;
  swimming_pools: number;
}

export const useUserReport = () => {
  return useQuery({
    queryKey: ['userReport'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('user_reports')
        .select('*')
        .maybeSingle();

      if (error) {
        throw error;
      }

      return data as UserReport;
    },
  });
};
